import { render } from "./companies-details-modal.vue?vue&type=template&id=e5a58c68"
import script from "./companies-details-modal.vue?vue&type=script&lang=js"
export * from "./companies-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__